<script setup lang="ts">
import { FormRow } from '@shared/ui/form-row'
import { RadioItem } from '@shared/ui/radio'

import { useTutorApplicationStore } from '../../model/store'
import { useWorkRequiredSchedule } from '../../model/additional-questions/work-required-schedule.hooks'
import { yesNoOptions } from '../../config/additional-questions'

defineOptions({
  name: 'WorkRequiredSchedule',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  label,
  mode,
  setWorkRequiredSchedule,
} = useWorkRequiredSchedule()

</script>

<template>
  <FormRow
    :label="label"
    required
  >
    <RadioItem
      v-for="option in yesNoOptions"
      :key="option.value.toString()"
      :label="option.label"
      :mode="mode"
      :checked="tutorApplicationStore.workRequiredSchedule === option.value"
      @click="setWorkRequiredSchedule(option.value)"
    />
  </FormRow>
</template>
